var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 242,
    viewBox: "0 0 315 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5049 59.5255L80.1906 27.5532C124.876 -5.91685 189.111 -9.22272 237.863 19.4386L248.105 25.4601C299.128 55.4563 315.876 115.034 286.7 162.755C271.549 194.998 236.021 216 196.628 216H157.293C109.726 216 64.7387 196.828 35.024 163.892L26.9941 154.992C22.3467 149.841 18.5596 144.124 15.7493 138.016C3.05889 110.436 11.8423 78.7472 37.5049 59.5255Z",
    fill: "#E8F0FE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.5,
    cy: 226.5,
    rx: 157.5,
    ry: 15.5,
    fill: "#F3F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8384 24.77H75.5082V209.076H86.8384V24.77Z",
    fill: "url(#paint0_linear_8001_1759)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0522 175.614H72.2912V226.436H90.0522V175.614Z",
    fill: "url(#paint1_linear_8001_1759)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0522 175.614H72.2912L75.5082 173.493H86.8352L90.0522 175.614Z",
    fill: "url(#paint2_linear_8001_1759)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.8384 43.0808H75.5082V51.1209H86.8384V43.0808Z",
    fill: "url(#paint3_linear_8001_1759)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M72.2881 226.439H90.0491V209.079H72.2881V226.439Z",
    fill: "url(#paint4_linear_8001_1759)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.706 24.77H225.376V209.076H236.706V24.77Z",
    fill: "url(#paint5_linear_8001_1759)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92 175.614H222.159V226.436H239.92V175.614Z",
    fill: "url(#paint6_linear_8001_1759)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92 175.614H222.159L225.376 173.493H236.703L239.92 175.614Z",
    fill: "url(#paint7_linear_8001_1759)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M222.159 226.439H239.92V209.079H222.159V226.439Z",
    fill: "url(#paint8_linear_8001_1759)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M236.706 43.0808H225.376V51.1209H236.706V43.0808Z",
    fill: "url(#paint9_linear_8001_1759)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.474 126.745V25.1079C263.474 19.4805 258.888 14.9185 253.231 14.9185L58.9831 14.9185C53.3265 14.9185 48.7409 19.4805 48.7409 25.1079V126.745C48.7409 132.372 53.3265 136.934 58.9831 136.934H253.231C258.888 136.934 263.474 132.372 263.474 126.745Z",
    fill: "url(#paint10_linear_8001_1759)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.285 15.7507H58.9265C53.7614 15.7507 49.5743 19.9163 49.5743 25.0547V126.798C49.5743 131.937 53.7614 136.102 58.9265 136.102H253.285C258.45 136.102 262.637 131.937 262.637 126.798V25.0547C262.637 19.9163 258.45 15.7507 253.285 15.7507Z",
    fill: "url(#paint11_linear_8001_1759)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.398 20.7343C253.784 20.7343 255.114 21.2821 256.094 22.2572C257.074 23.2323 257.625 24.5548 257.625 25.9338V125.916C257.625 126.599 257.489 127.275 257.227 127.906C256.964 128.536 256.579 129.11 256.094 129.592C255.608 130.075 255.032 130.458 254.398 130.72C253.764 130.981 253.084 131.115 252.398 131.115H59.8101C58.424 131.115 57.0946 130.567 56.1145 129.592C55.1343 128.617 54.5837 127.295 54.5837 125.916V25.9338C54.5837 24.5548 55.1343 23.2323 56.1145 22.2572C57.0946 21.2821 58.424 20.7343 59.8101 20.7343H252.398ZM252.398 19.4048H59.8101C58.07 19.4064 56.4017 20.0948 55.1713 21.3189C53.9409 22.543 53.2489 24.2027 53.2472 25.9338V125.916C53.2489 127.647 53.9409 129.307 55.1713 130.531C56.4017 131.755 58.07 132.443 59.8101 132.445H252.398C254.138 132.443 255.807 131.755 257.037 130.531C258.267 129.307 258.959 127.647 258.961 125.916V25.9338C258.959 24.2027 258.267 22.543 257.037 21.3189C255.807 20.0948 254.138 19.4064 252.398 19.4048Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M156.106 235.893C219.549 235.893 270.98 232.684 270.98 228.726C270.98 224.768 219.549 221.559 156.106 221.559C92.6624 221.559 41.2315 224.768 41.2315 228.726C41.2315 232.684 92.6624 235.893 156.106 235.893Z",
    fill: "url(#paint12_radial_8001_1759)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M231.04 229.441C260.623 229.441 284.606 227.945 284.606 226.1C284.606 224.254 260.623 222.758 231.04 222.758C201.456 222.758 177.474 224.254 177.474 226.1C177.474 227.945 201.456 229.441 231.04 229.441Z",
    fill: "url(#paint13_radial_8001_1759)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M81.1717 229.441C110.755 229.441 134.738 227.945 134.738 226.1C134.738 224.254 110.755 222.758 81.1717 222.758C51.588 222.758 27.6057 224.254 27.6057 226.1C27.6057 227.945 51.588 229.441 81.1717 229.441Z",
    fill: "url(#paint14_radial_8001_1759)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8001_1759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.083 163H69.9974C68.6741 163 67.405 162.664 66.4691 162.066C65.5333 161.467 65.0074 160.656 65.0071 159.809V151.191C65.0071 150.345 65.5328 149.533 66.4687 148.935C67.4046 148.336 68.6739 148 69.9974 148H234.083C235.407 148 236.676 148.336 237.612 148.935C238.547 149.533 239.073 150.345 239.073 151.191V159.809C239.073 160.656 238.547 161.467 237.611 162.065C236.676 162.664 235.407 163 234.083 163Z",
    fill: "#FFCA02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.004 163H234.083C235.406 163 236.675 162.664 237.611 162.065C238.547 161.467 239.072 160.656 239.072 159.809V151.191C239.073 150.345 238.547 149.533 237.611 148.935C236.676 148.336 235.407 148 234.083 148H242.004C242.66 148 243.308 148.083 243.914 148.243C244.519 148.403 245.069 148.638 245.533 148.935C245.996 149.231 246.363 149.583 246.614 149.97C246.865 150.357 246.994 150.772 246.994 151.191V159.809C246.994 160.656 246.468 161.467 245.532 162.065C244.597 162.664 243.328 163 242.004 163H242.004Z",
    fill: "#EFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.093 156.282H141.556L143.494 158.108L145.657 160.147H154.093C154.894 160.147 155.663 159.943 156.229 159.581C156.796 159.218 157.115 158.727 157.115 158.214C157.115 157.702 156.796 157.21 156.229 156.848C155.663 156.485 154.894 156.282 154.093 156.282ZM121.414 156.282H101.109L105.21 160.147H125.514L122.658 157.455L121.413 156.282M80.9658 156.282H77.0397C76.2382 156.282 75.4696 156.485 74.9029 156.848C74.3362 157.21 74.0178 157.702 74.0178 158.214C74.0178 158.727 74.3362 159.218 74.9029 159.581C75.4696 159.943 76.2382 160.147 77.0397 160.147H85.0696L82.2119 157.455L80.9673 156.282",
    fill: "#FFE328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.306 156.282H183.388C182.969 156.281 182.556 156.336 182.173 156.444L182.563 156.812L186.103 160.146H206.407L204.243 158.107L202.306 156.281",
    fill: "#FFE328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.516 148H213.658L229.578 163H209.435L193.516 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.071 148H173.212L189.131 163H168.99L153.071 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.306 156.282L204.243 158.108L202.306 156.282Z",
    fill: "#FFE63B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.202 156.282H202.306L204.243 158.108L206.407 160.147H220.202C221.004 160.147 221.772 159.943 222.339 159.581C222.906 159.218 223.224 158.727 223.224 158.214C223.224 157.702 222.906 157.21 222.339 156.848C221.772 156.485 221.004 156.282 220.202 156.282Z",
    fill: "#5C5849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.174 156.445C181.539 156.623 181.018 156.935 180.701 157.33C180.383 157.724 180.287 158.177 180.429 158.611C180.572 159.045 180.944 159.435 181.482 159.715C182.021 159.994 182.694 160.147 183.388 160.147H186.103L182.563 156.813L182.173 156.445",
    fill: "#5C5849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.624 148H132.765L148.685 163H128.544L112.624 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.554 156.282H121.413L122.658 157.455L125.515 160.147H145.656L143.493 158.108L141.554 156.282Z",
    fill: "#5C5849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1785 148H92.3196L108.238 163H88.0971L72.1785 148Z",
    fill: "#474337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.108 156.282H80.9665L82.2112 157.455L85.0689 160.147H105.21L101.108 156.282Z",
    fill: "#5C5849"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8001_1759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.73 196.669C46.583 196.186 46.2844 195.764 45.8783 195.464C45.4723 195.163 44.9802 195.001 44.4748 195.002H39.5246C39.0193 195.001 38.5274 195.163 38.1214 195.464C37.7154 195.764 37.4169 196.186 37.27 196.669L28.179 226.505H55.8204L46.7298 196.669",
    fill: "#F8812F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7503 226.505H25.2495C24.9181 226.505 24.6003 226.637 24.366 226.87C24.1316 227.104 24 227.421 24 227.752C24 228.083 24.1316 228.4 24.366 228.633C24.6003 228.867 24.9181 228.998 25.2495 228.998H58.7503C59.0817 228.998 59.3995 228.867 59.6338 228.633C59.8682 228.4 59.9998 228.083 59.9998 227.752C59.9998 227.421 59.8682 227.104 59.6338 226.87C59.3995 226.637 59.0817 226.505 58.7503 226.505Z",
    fill: "#F4690B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7632 228.999H58.7504C59.0817 228.999 59.3995 228.867 59.6339 228.634C59.8682 228.4 59.9999 228.083 60 227.752C59.9999 228.081 59.8699 228.396 59.6384 228.629C59.4068 228.862 59.0923 228.995 58.7632 228.999Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7503 228.999H48.205C48.5364 228.997 48.8535 228.864 49.0866 228.629C49.3198 228.394 49.4498 228.076 49.4481 227.746C49.4464 227.415 49.3131 227.099 49.0776 226.866C48.842 226.634 48.5236 226.504 48.1922 226.506H58.7503C59.0817 226.506 59.3995 226.637 59.6338 226.871C59.8682 227.104 59.9998 227.422 59.9998 227.752C59.9998 228.083 59.8682 228.4 59.6338 228.634C59.3995 228.867 59.0817 228.999 58.7503 228.999Z",
    fill: "#F04E06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8206 226.505L53.9713 220.437L53.5066 218.911L55.8206 226.505Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8206 226.505H47.9352L47.1409 220.437H53.9713L55.8206 226.505Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.575 209.288L50.1619 207.933L50.575 209.288Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8805 213.574L50.575 209.289V209.289L51.8805 213.574Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8805 213.574H46.243L45.5049 207.933H50.1619L50.575 209.288V209.289L51.8805 213.574Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6596 206.284L48.0707 201.07L47.423 198.944L49.6596 206.284Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0707 201.07H44.6072L44.0314 196.669C43.9011 195.678 43.5082 195.002 43.0637 195.002H44.4758C44.9811 195.002 45.4731 195.164 45.8791 195.464C46.2851 195.764 46.5837 196.186 46.7309 196.669L47.424 198.944L48.0716 201.07",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8114 210.715C37.7576 210.715 37.7038 210.711 37.6506 210.704C37.3633 210.662 37.1046 210.507 36.9313 210.275C36.758 210.042 36.6843 209.751 36.7264 209.464L36.9518 207.933H39.166L38.8941 209.781C38.856 210.041 38.7258 210.277 38.5272 210.449C38.3286 210.62 38.0749 210.715 37.8123 210.715M40.1758 201.07H37.9612L38.1824 199.57C38.2247 199.283 38.3793 199.025 38.6123 198.852C38.8454 198.679 39.1377 198.606 39.425 198.648C39.7124 198.69 39.9711 198.844 40.1445 199.077C40.3178 199.309 40.3914 199.601 40.3492 199.887L40.175 201.07",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9615 223.289C35.9077 223.289 35.854 223.285 35.8007 223.277C35.6585 223.256 35.5217 223.208 35.3983 223.134C35.2748 223.061 35.1671 222.963 35.0813 222.848C34.9955 222.733 34.9333 222.602 34.8981 222.463C34.863 222.324 34.8557 222.179 34.8766 222.038L35.1122 220.437H37.3255L37.0433 222.355C37.0053 222.614 36.8752 222.851 36.6766 223.022C36.478 223.194 36.2242 223.288 35.9615 223.289Z",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8381 207.933H50.1619L48.0707 201.07H35.929L33.8381 207.933Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0283 220.437H53.9713L51.8805 213.574H32.1195L30.0283 220.437Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1619 207.933H45.5049L44.6072 201.07H48.0707L50.1619 207.933Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9713 220.437H47.1409L46.243 213.574H51.8805L53.9713 220.437Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1651 207.933H36.9518L37.9612 201.07H40.175L39.1651 207.933Z",
    fill: "#EFEDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3255 220.437H35.1122L35.7388 216.178C35.7769 215.918 35.9071 215.681 36.1058 215.51C36.3044 215.338 36.5583 215.244 36.8209 215.244C36.8746 215.244 36.9281 215.248 36.9812 215.255C37.2684 215.297 37.5271 215.452 37.7004 215.684C37.8737 215.917 37.9474 216.208 37.9054 216.495L37.3255 220.437Z",
    fill: "#EFEDE3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8001_1759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.73 196.669C273.583 196.186 273.284 195.764 272.878 195.464C272.472 195.163 271.98 195.001 271.475 195.002H266.525C266.019 195.001 265.527 195.163 265.121 195.464C264.715 195.764 264.417 196.186 264.27 196.669L255.179 226.505H282.82L273.73 196.669",
    fill: "#F8812F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 226.505H252.249C251.918 226.505 251.6 226.637 251.366 226.87C251.132 227.104 251 227.421 251 227.752C251 228.083 251.132 228.4 251.366 228.633C251.6 228.867 251.918 228.998 252.249 228.998H285.75C286.082 228.998 286.4 228.867 286.634 228.633C286.868 228.4 287 228.083 287 227.752C287 227.421 286.868 227.104 286.634 226.87C286.4 226.637 286.082 226.505 285.75 226.505Z",
    fill: "#F4690B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.763 228.999H285.75C286.082 228.999 286.4 228.867 286.634 228.634C286.868 228.4 287 228.083 287 227.752C287 228.081 286.87 228.396 286.638 228.629C286.407 228.862 286.092 228.995 285.763 228.999Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 228.999H275.205C275.536 228.997 275.854 228.864 276.087 228.629C276.32 228.394 276.45 228.076 276.448 227.746C276.446 227.415 276.313 227.099 276.078 226.866C275.842 226.634 275.524 226.504 275.192 226.506H285.75C286.082 226.506 286.4 226.637 286.634 226.871C286.868 227.104 287 227.422 287 227.752C287 228.083 286.868 228.4 286.634 228.634C286.4 228.867 286.082 228.999 285.75 228.999Z",
    fill: "#F04E06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.821 226.505L280.971 220.437L280.507 218.911L282.821 226.505Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.821 226.505H274.935L274.141 220.437H280.971L282.821 226.505Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.575 209.288L277.162 207.933L277.575 209.288Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88 213.574L277.575 209.289V209.289L278.88 213.574Z",
    fill: "#F07B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88 213.574H273.243L272.505 207.933H277.162L277.575 209.288V209.289L278.88 213.574Z",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.66 206.284L275.071 201.07L274.423 198.944L276.66 206.284Z",
    fill: "#82613F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.071 201.07H271.607L271.031 196.669C270.901 195.678 270.508 195.002 270.064 195.002H271.476C271.981 195.002 272.473 195.164 272.879 195.464C273.285 195.764 273.584 196.186 273.731 196.669L274.424 198.944L275.072 201.07",
    fill: "#F4601C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.811 210.715C264.758 210.715 264.704 210.711 264.651 210.704C264.363 210.662 264.105 210.507 263.931 210.275C263.758 210.042 263.684 209.751 263.726 209.464L263.952 207.933H266.166L265.894 209.781C265.856 210.041 265.726 210.277 265.527 210.449C265.329 210.62 265.075 210.715 264.812 210.715M267.176 201.07H264.961L265.182 199.57C265.225 199.283 265.379 199.025 265.612 198.852C265.845 198.679 266.138 198.606 266.425 198.648C266.712 198.69 266.971 198.844 267.144 199.077C267.318 199.309 267.391 199.601 267.349 199.887L267.175 201.07",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.962 223.289C262.908 223.289 262.854 223.285 262.801 223.277C262.658 223.256 262.522 223.208 262.398 223.134C262.275 223.061 262.167 222.963 262.081 222.848C261.996 222.733 261.933 222.602 261.898 222.463C261.863 222.324 261.856 222.179 261.877 222.038L262.112 220.437H264.325L264.043 222.355C264.005 222.614 263.875 222.851 263.677 223.022C263.478 223.194 263.224 223.288 262.962 223.289Z",
    fill: "#FCA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.838 207.933H277.162L275.071 201.07H262.929L260.838 207.933Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.028 220.437H280.971L278.88 213.574H259.12L257.028 220.437Z",
    fill: "#E2DED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.162 207.933H272.505L271.607 201.07H275.071L277.162 207.933Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.971 220.437H274.141L273.243 213.574H278.88L280.971 220.437Z",
    fill: "#BAB6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.165 207.933H263.952L264.961 201.07H267.175L266.165 207.933Z",
    fill: "#EFEDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.325 220.437H262.112L262.739 216.178C262.777 215.918 262.907 215.681 263.106 215.51C263.304 215.338 263.558 215.244 263.821 215.244C263.875 215.244 263.928 215.248 263.981 215.255C264.268 215.297 264.527 215.452 264.7 215.684C264.874 215.917 264.947 216.208 264.905 216.495L264.325 220.437Z",
    fill: "#EFEDE3"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.572 61.684V70H115.244V46.096H125.972C131.948 46.096 135.008 48.76 135.008 53.908C135.008 57.724 133.316 60.172 130.004 61.144L135.728 70H129.464L124.604 61.684H120.572ZM120.572 56.932H125.756C128.384 56.932 129.608 55.96 129.608 53.908C129.608 51.82 128.384 50.848 125.756 50.848H120.572V56.932ZM146.887 52.72C152.179 52.72 155.923 56.356 155.923 61.54C155.923 66.688 152.179 70.36 146.887 70.36C141.559 70.36 137.815 66.688 137.815 61.54C137.815 56.356 141.559 52.72 146.887 52.72ZM146.887 56.896C144.331 56.896 142.567 58.804 142.567 61.54C142.567 64.276 144.331 66.184 146.887 66.184C149.407 66.184 151.171 64.276 151.171 61.54C151.171 58.804 149.407 56.896 146.887 56.896ZM176.099 70H172.175L172.031 67.732H171.959C170.843 69.388 168.971 70.36 166.451 70.36C161.663 70.36 158.171 66.652 158.171 61.54C158.171 56.428 161.663 52.72 166.451 52.72C168.935 52.72 170.843 53.656 171.923 55.276H171.995L172.175 53.08H176.099V70ZM167.243 66.184C169.763 66.184 171.527 64.276 171.527 61.54C171.527 58.804 169.763 56.896 167.243 56.896C164.687 56.896 162.923 58.804 162.923 61.54C162.923 64.276 164.687 66.184 167.243 66.184ZM197.228 70H193.304L193.16 67.732H193.088C191.972 69.388 190.1 70.36 187.58 70.36C182.792 70.36 179.3 66.652 179.3 61.54C179.3 56.428 182.792 52.72 187.58 52.72C189.668 52.72 191.288 53.368 192.44 54.52H192.512V44.8H197.228V70ZM188.372 66.184C190.892 66.184 192.656 64.276 192.656 61.54C192.656 58.804 190.892 56.896 188.372 56.896C185.816 56.896 184.052 58.804 184.052 61.54C184.052 64.276 185.816 66.184 188.372 66.184ZM115.562 85.736C118.874 85.736 120.998 86.312 122.906 87.608V93.44H122.654C121.142 91.532 118.73 90.488 115.814 90.488C111.206 90.488 108.182 93.512 108.182 98.048C108.182 102.584 111.206 105.608 115.814 105.608C118.694 105.608 121.142 104.6 122.654 102.656H122.906V108.488C120.998 109.748 118.838 110.36 115.562 110.36C107.93 110.36 102.782 105.248 102.782 98.048C102.782 90.848 107.93 85.736 115.562 85.736ZM126.676 110V84.8H131.392V110H126.676ZM143.671 92.72C148.963 92.72 152.707 96.356 152.707 101.54C152.707 106.688 148.963 110.36 143.671 110.36C138.343 110.36 134.599 106.688 134.599 101.54C134.599 96.356 138.343 92.72 143.671 92.72ZM143.671 96.896C141.115 96.896 139.351 98.804 139.351 101.54C139.351 104.276 141.115 106.184 143.671 106.184C146.191 106.184 147.955 104.276 147.955 101.54C147.955 98.804 146.191 96.896 143.671 96.896ZM162.226 92.72C164.278 92.72 166.222 93.116 167.554 93.8V98.3H167.374C166.258 97.184 164.53 96.608 162.334 96.608C160.498 96.608 159.598 97.148 159.598 98.192C159.598 98.948 160.174 99.272 162.406 99.416C166.906 99.704 168.67 101.288 168.67 104.852C168.67 108.308 166.078 110.36 161.722 110.36C158.914 110.36 156.754 109.856 155.314 108.848V104.312H155.53C156.862 105.752 158.878 106.472 161.506 106.472C163.342 106.472 164.242 105.932 164.242 104.852C164.242 103.952 163.522 103.592 161.146 103.376C156.862 102.98 155.17 101.684 155.17 98.336C155.17 94.916 157.942 92.72 162.226 92.72ZM188.091 102.728H175.491C175.995 105.032 178.083 106.292 180.999 106.292C183.447 106.292 185.535 105.572 186.903 104.24H187.083V108.776C185.679 109.784 183.411 110.36 180.783 110.36C174.807 110.36 170.739 106.76 170.739 101.54C170.739 96.356 174.411 92.72 179.559 92.72C184.815 92.72 188.091 95.852 188.091 100.82V102.728ZM179.703 96.788C177.687 96.788 175.959 97.904 175.491 99.884H183.843C183.519 97.832 181.935 96.788 179.703 96.788ZM208.249 110H204.325L204.181 107.732H204.109C202.993 109.388 201.121 110.36 198.601 110.36C193.813 110.36 190.321 106.652 190.321 101.54C190.321 96.428 193.813 92.72 198.601 92.72C200.689 92.72 202.309 93.368 203.461 94.52H203.533V84.8H208.249V110ZM199.393 106.184C201.913 106.184 203.677 104.276 203.677 101.54C203.677 98.804 201.913 96.896 199.393 96.896C196.837 96.896 195.073 98.804 195.073 101.54C195.073 104.276 196.837 106.184 199.393 106.184Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8001_1759",
    x1: 75.5082,
    y1: 116.925,
    x2: 86.8353,
    y2: 116.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8001_1759",
    x1: 72.387,
    y1: 200.8,
    x2: 90.1528,
    y2: 200.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8001_1759",
    x1: 72.387,
    y1: 171.583,
    x2: 90.1528,
    y2: 171.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8001_1759",
    x1: 81.1717,
    y1: 51.1178,
    x2: 81.1717,
    y2: 43.0808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8001_1759",
    x1: 81.1686,
    y1: 209.079,
    x2: 81.1686,
    y2: 226.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8001_1759",
    x1: 225.376,
    y1: 116.925,
    x2: 236.703,
    y2: 116.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8001_1759",
    x1: 222.284,
    y1: 200.8,
    x2: 240.05,
    y2: 200.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8001_1759",
    x1: 222.284,
    y1: 171.583,
    x2: 240.05,
    y2: 171.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8001_1759",
    x1: 231.04,
    y1: 209.079,
    x2: 231.04,
    y2: 226.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8001_1759",
    x1: 231.04,
    y1: 51.1178,
    x2: 231.04,
    y2: 43.0808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8001_1759",
    x1: 156.109,
    y1: 136.931,
    x2: 156.109,
    y2: 14.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#4F430E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8001_1759",
    x1: 104.992,
    y1: 164.002,
    x2: 206.429,
    y2: -12.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C33303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#E26213"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_8001_1759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.968 228.828) scale(114.876 7.17017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_8001_1759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.89 226.202) scale(53.5697 3.34365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_8001_1759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.0289 226.202) scale(53.5697 3.34365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8001_1759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 65 163)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8001_1759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(24 195)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8001_1759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(251 195)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadClosed);
export default __webpack_public_path__ + "static/media/road-closed.2845bf3171f795a4b7e8c0e24c803e44.svg";
export { ForwardRef as ReactComponent };